export class FiltroFinanciamentoDTO {
  public codigo!: string;
  public nome!: string;
  public status!: string;
  public tipoProposta!: string;
  public promotora!: number;
  public empregador!: number;
}